import type { CityConfig } from "../city-template/types";

export const clintonTownshipConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — marriage license issuance" },
    { label: "Divorce Records — Macomb County Clerk", href: "https://www.macombgov.org/clerk", description: "Macomb County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Clinton Township",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "clinton-township",
  route: "/clinton-township",
  title: "Emergency Passport Clinton Township, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Clinton Township, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Clinton Township, Mount Clemens, Sterling Heights, and all Macomb County residents. Detroit Passport Agency alternative. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Clinton Township, MI",
  heroSubtitle: "Clinton Township travelers — from northern Macomb County families to Mount Clemens commuters to international vacationers — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Our couriers have direct access to the Detroit Passport Agency. A+ BBB rated courier service serving all of Macomb County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suburban%20Michigan%20northern%20Macomb%20County%20community%20with%20modern%20retail%20centers%20and%20residential%20neighborhoods%2C%20wide%20boulevards%20and%20tree-lined%20streets%2C%20late%20afternoon%20with%20warm%20sunlight%2C%20clean%20suburban%20streets%20with%20well-maintained%20commercial%20and%20residential%20areas%2C%20no%20text%20no%20people%2C%20American%20suburban%20community%20photography%2C%20open%20spaces%20and%20parks%20visible%20in%20the%20background&width=1800&height=700&seq=clinton-township-hero-001&orientation=landscape",
  heroImageAlt: "Clinton Township Michigan suburban community with modern retail and residential neighborhoods in Macomb County",
  geoPosition: "42.5869;-82.9195",
  geoPlacename: "Clinton Township, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 30 miles south of Clinton Township — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Clinton Township", zips: "48035, 48036, 48038" },
    { name: "Mount Clemens", zips: "48043" },
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Roseville", zips: "48066" },
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Eastpointe", zips: "48021" },
    { name: "Fraser", zips: "48026" },
    { name: "Shelby Township", zips: "48315, 48316, 48317" },
    { name: "Utica", zips: "48315, 48317" },
    { name: "Saint Clair Shores", zips: "48080, 48081, 48082" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Canada Border Travel", desc: "Expertise for Blue Water Bridge and Ambassador Bridge crossings" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any UPS or FedEx in Macomb County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Sterling Heights, MI", route: "/sterling-heights" },
    { name: "Emergency passport services in Roseville, MI", route: "/roseville-mi" },
    { name: "Michigan passport services overview", route: "/michigan" },
    { name: "Urgent passport services in Detroit, MI", route: "/detroit" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Clinton Township, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Clinton Township residents can ship from any UPS or FedEx in Macomb County.",
  fpcOfficeDistance: "Serving Clinton Township, Mount Clemens, Sterling Heights, Shelby Township, Utica, Fraser, Roseville, and all of northern Macomb County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Clinton Township and northern Macomb County. From the Hall Road corridor to the Mount Clemens county seat, from the northern borders near Shelby Township to the southern edge near Fraser — we serve all of Macomb County. Our courier service brings the Detroit Passport Agency directly to your doorstep.",
  nearbyCitiesIntro: "We serve Clinton Township and all northern Macomb County communities including Mount Clemens, Sterling Heights, Shelby Township, Utica, Fraser, Roseville, Warren, Eastpointe, Saint Clair Shores, and Center Line. We also serve travelers crossing the Blue Water Bridge to Canada.",
  howItWorksIntro: "Most Clinton Township travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Northern Macomb County residents are busy families and commuters who often discover passport issues right before travel. Here are the most common passport mistakes we see from Clinton Township and Mount Clemens travelers.",
  testimonialsIntro: "Clinton Township and northern Macomb County travelers — from families to business commuters to international vacationers — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Clinton Township, MI? Here are the most common ones we hear from northern Macomb County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — 30+ miles each way"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Clinton Township and northern Macomb County travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips, family emergencies, and Canada border crossings.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Blue Water Bridge and Canada travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Clinton Township adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Macomb County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Clinton Township residents and families — including commuters, families, and new citizens.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Clinton Township and Macomb County residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Clinton Township-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Clinton Township and Macomb County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Clinton Township MI", description: "Urgent passport processing for Clinton Township Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Clinton Township MI", description: "Fast passport renewal for Clinton Township Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Clinton Township MI", description: "New passport application services for Clinton Township Michigan residents applying for their first passport." },
    { name: "Child Passport Clinton Township MI", description: "Minor passport services for Clinton Township Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michelle R.",
      location: "Clinton Township, MI",
      rating: 5,
      text: "Cruise to the Bahamas in 6 days and our whole family's passports were expired. Fast Passport Center handled all five renewals in 4 days. We shipped from the UPS on Hall Road and everything was perfect. Best service in Macomb County.",
      service: "Family Passport Bundle",
    },
    {
      name: "Kevin B.",
      location: "Mount Clemens, MI",
      rating: 5,
      text: "Business trip to Germany with 3 days notice. My passport had less than 6 months validity. Fast Passport Center got me a renewed passport in 36 hours. The courier service saved me a full day of driving to Detroit.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Amanda S.",
      location: "Shelby Township, MI",
      rating: 5,
      text: "First-time passport for our honeymoon to Jamaica. Fast Passport Center caught a problem with my birth certificate that the post office would have rejected. Fixed it and got our passports in 5 days. Couldn't be happier.",
      service: "First-Time Passport",
    },
    {
      name: "David H.",
      location: "Clinton Township, MI",
      rating: 5,
      text: "Lost my passport two days before a trip to Cancun. Fast Passport Center had a replacement in my hands in 48 hours. I thought my vacation was ruined but they saved it. Incredible.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "clinton-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 30 miles south of Clinton Township — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "clinton-2",
      name: "Clinton Township Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40700 Garfield Rd",
      city: "Clinton Township",
      state: "MI",
      zip: "48038",
      phone: "(586) 228-6100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Clinton Township — near Hall Road corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Clinton Township acceptance facility. Serves northern Macomb County including Clinton Township, Mount Clemens, and Fraser. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-3",
      name: "Mount Clemens Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "155 S Walnut St",
      city: "Mount Clemens",
      state: "MI",
      zip: "48043",
      phone: "(586) 463-5220",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Mount Clemens — approximately 5 miles east of Clinton Township",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Mount Clemens and the eastern Macomb County area. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-4",
      name: "Sterling Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40111 Dodge Park Rd",
      city: "Sterling Heights",
      state: "MI",
      zip: "48313",
      phone: "(586) 247-4000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sterling Heights — approximately 8 miles north of Clinton Township",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Macomb County residents including Sterling Heights, Shelby Township, and Utica. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
    {
      id: "clinton-5",
      name: "Roseville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "27300 Gratiot Ave",
      city: "Roseville",
      state: "MI",
      zip: "48066",
      phone: "(586) 777-8880",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Roseville — approximately 8 miles south of Clinton Township",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Macomb County residents including Roseville, Eastpointe, and southern Warren. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must drive 30+ miles to downtown", fpc: "No — ship from anywhere in Macomb County" },
    { feature: "Canada Border Expertise", agency: "No tailored advice", fpc: "Yes — Blue Water Bridge, Windsor, and Canada travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Northern Macomb County families and commuters often discover passport issues right before travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel to Canada",
      description: "Many Macomb County residents crossing to Windsor use a passport card or enhanced license — but these are not valid for air travel. If you fly to Canada, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Macomb County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Canada Entry Requirements",
      description: "Canada has its own entry requirements separate from passport validity. Blue Water Bridge and Windsor travelers should verify current Canadian customs and immigration rules before crossing.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in northern Macomb County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Clinton Township, Mount Clemens, or Sterling Heights." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Macomb County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport acceptance facility in Clinton Township, MI?", a: "The Clinton Township Post Office at 40700 Garfield Rd is the primary acceptance facility in Clinton Township. The Mount Clemens Post Office at 155 S Walnut St and the Sterling Heights Post Office at 40111 Dodge Park Rd are also nearby. All require appointments. Fast Passport Center eliminates the need for an in-person visit — our couriers handle everything." },
    { q: "How fast can I get an emergency passport in Clinton Township, MI?", a: "Fast Passport Center offers emergency passport processing in Clinton Township, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 30+ miles to downtown Detroit." },
    { q: "Do I need a passport to cross the Blue Water Bridge to Canada?", a: "For air travel to Canada, yes — you need a passport book. For land crossings via the Blue Water Bridge, Ambassador Bridge, or Detroit-Windsor Tunnel, U.S. citizens can use a passport book, passport card, enhanced driver's license, or Trusted Traveler card. A passport book provides the most flexibility for all types of travel." },
    { q: "Can I get an expedited passport in the northern Macomb County suburbs?", a: "Absolutely. Fast Passport Center serves all of northern Macomb County including Clinton Township, Mount Clemens, Sterling Heights, Shelby Township, Utica, Fraser, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do northern Macomb County travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for northern Macomb County residents, approximately 35–40 minutes from Clinton Township. DTW offers direct flights to London, Amsterdam, Tokyo, Mexico City, Cancun, and dozens of other international destinations. Windsor Airport (YQG) is a secondary option. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Clinton Township, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Clinton Township residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Macomb County offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve all of northern Macomb County?", a: "Yes. Fast Passport Center serves all of northern Macomb County including Clinton Township, Mount Clemens, Sterling Heights, Shelby Township, Utica, Fraser, and all surrounding communities. Our courier service is especially valuable for busy families who don't have time to drive to downtown Detroit." },
  ],
  photoLocations: [
    { name: "Walgreens — Clinton Township", address: "44000 Garfield Rd, Clinton Township, MI 48038", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Sterling Heights", address: "36650 Van Dyke Ave, Sterling Heights, MI 48312", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "UPS Store — Clinton Township", address: "43300 Garfield Rd, Clinton Township, MI 48038", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/", websiteLabel: "UPS Store" },
    { name: "FedEx Office — Mount Clemens", address: "30 N Walnut St, Mount Clemens, MI 48043", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/office/passport-photos.html", websiteLabel: "FedEx Office" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Clinton Township", address: "42700 Garfield Rd, Clinton Township, MI 48038", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves northern Macomb County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Mount Clemens", address: "15 N Walnut St, Mount Clemens, MI 48043", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Mount Clemens and eastern Macomb County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "35–40 minutes from Clinton Township via I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Metro Detroit. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "50–55 minutes from Clinton Township via I-94 and Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for Macomb County travelers crossing to Canada first. Smaller airport with limited international routes. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};